import { createSlice } from '@reduxjs/toolkit';
import { PLATFORM_FEATURE_KEY } from '@clatter/platform';

export const PM_SESSION_ID_FEATURE_KEY = 'pmSessionId';

export const pmSessionIdInitialState = {
  id: null,
};

export const pmSessionIdSlice = createSlice({
  name: PM_SESSION_ID_FEATURE_KEY,
  initialState: pmSessionIdInitialState,
  reducers: {
    setPmSessionId: (state, { payload }) => {
      console.log('pm session started', payload);
      state.id = payload;
    },
    clearPmSessionId: (state) => {
      console.log('pm session ended', state.id);
      state.id = null;
    },
  },
});

export const { setPmSessionId, clearPmSessionId } = pmSessionIdSlice.actions;
export const pmSessionIdReducer = pmSessionIdSlice.reducer;

export const getPmSessionIdState = (rootState) => rootState[PLATFORM_FEATURE_KEY][PM_SESSION_ID_FEATURE_KEY];

export const pmSessionIdSelectors = {
  getPmSessionId: (rootState) => getPmSessionIdState(rootState).id,
};
